import { waitUntil } from "@vercel/functions";
import { createServerOnlyFn } from "@tanstack/react-start";
import { metaEnvironment } from "@wags/meta-graph/config.ts";
import { receiveMetaWebhook } from "@wags/meta-graph/ingress.ts";
import { metaGraphManifest } from "@wags/meta-graph/telemetry.ts";
import { createWagsTelemetry } from "@/lib/core/telemetry.server";

const handleMetaWebhook = createServerOnlyFn(
    async ({ request }: { request: Request }) => {
        const telemetry = await createWagsTelemetry(metaGraphManifest);
        const response = await receiveMetaWebhook(request, {
            environment: metaEnvironment(process.env.VERCEL_ENV),
            telemetry,
            credentials: [
                {
                    appId: process.env.META_GRAPH_APP_ID ?? "",
                    appSecret: process.env.META_GRAPH_APP_SECRET ?? "",
                },
                {
                    appId: process.env.META_INSTAGRAM_APP_ID ?? "",
                    appSecret: process.env.META_INSTAGRAM_APP_SECRET ?? "",
                },
            ],
            verifyToken: process.env.META_GRAPH_WEBHOOK_VERIFY_TOKEN ?? "",
        });
        waitUntil(telemetry.flush());
        return response;
    },
);

export const apiWebhooksMetaRoute = {
    server: { handlers: { GET: handleMetaWebhook, POST: handleMetaWebhook } },
};
